import AddImage from "assets/add-image-blue.png";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Nestable from "helpers/ReactNestable";
import { useMutation, useQuery } from "@apollo/client";
import RenderItem from "helpers/ReactNestable/RenderItem";
import Handler from "helpers/ReactNestable/Handler";
import {
  CREATE_PRODUCT_OPTION,
  DELETE_PRODUCT_OPTION,
  UPDATE_PRODUCT_OPTION,
} from "modules/Products/Services/Mutations/Mutation";
import { PRODUCT_OPTION_COLLECTION_QUERY } from "modules/Products/Services/Queries/Queries";
import ProductShowModal from "helpers/ProductShowModal";
import ProductDeleteModal from "helpers/ProductDeleteModal";
import useDisableBodyScroll from "helpers/DisableBodyScroll";
import { findParentNextAndPrevioutId } from "helpers/utils";
import checkIsTowObjectEqual from "lodash";
import { LoadingDesign, OopsNoDataDesign } from "helpers";

interface FormType {
  title: string;
  parent: number;
  options: string;
}

const ProductsOption = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [editProduct, setEditProduct] = useState<{
    id: number;
    name: string;
    options?: string;
  }>();
  const [item, setItem] = useState<
    {
      id: number;
      name: string;
      children: [] | any[];
    }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [dragId, setDragId] = useState<any>();
  const [updatedArrayObject, setUpdatedArrayObject] = useState<any>();
  const [currentArrayObject, setcurrentArrayObject] = useState<any>();
  const [loadingUpdateProductOptions, setLoadingloadingUpdateProductOptions] =
    useState(false);
  const [createProductOptions] = useMutation(CREATE_PRODUCT_OPTION);
  const [updateProductOptions] = useMutation(UPDATE_PRODUCT_OPTION);
  const [deleteProductOption] = useMutation(DELETE_PRODUCT_OPTION);

  const {
    data: productOptions,
    loading: loadingProductOptions,
    refetch,
  } = useQuery(PRODUCT_OPTION_COLLECTION_QUERY, {
    variables: {
      requiredFields: ["id", "title", "options"],
    },
    notifyOnNetworkStatusChange: true,
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    clearErrors,
    reset,
  } = useForm<FormType>();

  const createProductOptionHandler = (data: FormType) => {
    if (!loading) {
      setLoading(true);
      createProductOptions({
        variables: {
          title: data?.title,
          parentId: +data.parent ? +data.parent : undefined,
          options: data?.options || undefined,
        },
      })
        .then(() => {
          setLoading(false);
          setShowModal(!showModal);
          refetch();
        })
        .catch((errors: any) => {
          setLoading(false);
          alert(errors.message);
        });
    }
  };

  const updateProductOptionHandler = (data: FormType) => {
    if (!loading) {
      setLoading(true);
      setLoadingloadingUpdateProductOptions(true);
      updateProductOptions({
        variables: {
          id: editProduct?.id,
          title: data?.title ? data?.title : "",
          options: data?.options || undefined,
        },
      })
        .then(() => {
          setLoading(false);
          setShowEditModal(!showEditModal);
          refetch();
          setLoadingloadingUpdateProductOptions(false);
        })
        .catch((errors: any) => {
          setLoading(false);
          // alert(error?.message);(errors.message);
          setLoadingloadingUpdateProductOptions(false);
        });
    }
  };

  useEffect(() => {
    reset();
    clearErrors("title");
  }, [clearErrors, showModal, reset, showEditModal]);

  const getParent: any = (
    object: { id: any; name: any; children: any[] },
    search: any,
  ) => {
    if (object.id === search) return [object?.id];
    else if (object.children || Array.isArray(object)) {
      let children = Array.isArray(object) ? object : object.children;
      for (let child of children) {
        let result = getParent(child, search);
        if (result) {
          if (object.id) result.unshift(object.id);
          return result;
        }
      }
    }
  };
  useEffect(() => {
    const productsOptionConvertionHandler: any = (
      productOptions: {
        id: number;
        title: string;
        children: [] | any[];
      }[],
    ) => {
      if (productOptions?.length === 0) return null;

      return productOptions?.map(
        (productOptions: {
          id: number;
          title: string;
          options?: string;
          children: [] | any[];
        }) => {
          return {
            id: productOptions?.id,
            name: productOptions?.title,
            options: productOptions?.options,
            children: productsOptionConvertionHandler(productOptions?.children)
              ? productsOptionConvertionHandler(productOptions?.children)
              : [],
          };
        },
      );
    };
    if (productOptions) {
      setItem(productsOptionConvertionHandler(productOptions?.productOptions));
    }
  }, [productOptions]);

  let selectOptions: any[] = [];

  const getSelectOptionsHandler = (treeData: any[]) => {
    if (treeData?.length === 0) return null;
    treeData?.map((treeData) => {
      selectOptions.push({
        id: treeData?.id,
        name: `${getParent(item, treeData?.id)?.length === 1 ? "" : ""}${
          getParent(item, treeData?.id)?.length === 2 ? "- " : ""
        }${
          getParent(item, treeData?.id)?.length === 3 ? "- - " : ""
        }${treeData?.name}`,
      });
      return treeData;
    });
  };
  getSelectOptionsHandler(item);
  useDisableBodyScroll(showModal);

  useEffect(() => {
    const getPath = (object: any, search: any) => {
      if (object?.id === search) return [object];
      else if (object?.children || Array.isArray(object)) {
        let children = Array.isArray(object) ? object : object?.children;
        for (let child of children) {
          let result: any = getPath(child, search);
          if (result) {
            if (object?.id) result?.unshift(object);
            return result;
          }
        }
      }
    };

    if (dragId) {
      let lengthForCurrent = getPath(item, dragId?.dragItem?.id)?.length;
      let parentforCurrentArray =
        lengthForCurrent === 3
          ? getPath(item, dragId?.dragItem?.id)[1]
          : lengthForCurrent === 2
            ? getPath(item, dragId?.dragItem?.id)[0]
            : lengthForCurrent === 1
              ? undefined
              : lengthForCurrent;

      if (parentforCurrentArray) {
        setcurrentArrayObject(
          findParentNextAndPrevioutId(
            parentforCurrentArray.children,
            dragId?.dragItem?.id,
            parentforCurrentArray?.id,
          ),
        );
      }
      if (parentforCurrentArray === undefined) {
        setcurrentArrayObject(
          findParentNextAndPrevioutId(item, dragId?.dragItem?.id),
        );
      }
      let length = getPath(dragId?.items, dragId?.dragItem?.id)?.length;
      let parentArray =
        length === 3
          ? getPath(dragId?.items, dragId?.dragItem?.id)[1]
          : length === 2
            ? getPath(dragId?.items, dragId?.dragItem?.id)[0]
            : length === 1
              ? undefined
              : length;
      if (parentArray) {
        setUpdatedArrayObject(
          findParentNextAndPrevioutId(
            parentArray.children,
            dragId?.dragItem?.id,
            parentArray?.id,
          ),
        );
      }
      if (parentArray === undefined) {
        setUpdatedArrayObject(
          findParentNextAndPrevioutId(dragId?.items, dragId?.dragItem?.id),
        );
      }
    }
  }, [dragId, item]);

  useEffect(() => {
    if (updatedArrayObject && dragId && currentArrayObject) {
      if (
        checkIsTowObjectEqual.isEqual(updatedArrayObject, currentArrayObject)
      ) {
        setUpdatedArrayObject(undefined);
        setcurrentArrayObject(undefined);
      }
      if (
        !checkIsTowObjectEqual.isEqual(updatedArrayObject, currentArrayObject)
      ) {
        setLoadingloadingUpdateProductOptions(true);
        const { id, nextId, parentId, previousId } = updatedArrayObject;
        updateProductOptions({
          variables: {
            id: id,
            nextId: nextId,
            parentId: parentId,
            previousId: previousId,
          },
        })
          .then(() => {
            refetch();
            setLoadingloadingUpdateProductOptions(false);
            setUpdatedArrayObject(undefined);
            setcurrentArrayObject(undefined);
            setDragId(undefined);
          })
          .catch((error) => {
            alert(error?.message);
            setLoadingloadingUpdateProductOptions(false);
            setUpdatedArrayObject(undefined);
            setcurrentArrayObject(undefined);
            setDragId(undefined);
          });
      }
    }
  }, [
    updatedArrayObject,
    updateProductOptions,
    dragId,
    refetch,
    currentArrayObject,
  ]);

  return (
    <div className="px-[10px]">
      <h1 className="text-[#393939] text-[32px] leading-10 pt-[10px]">
        Products Option
      </h1>
      <div className="flex items-center w-fit">
        <img
          src={AddImage}
          alt="add-icon"
          className="my-[25px] cursor-pointer"
          onClick={() => setShowModal(!showModal)}
        />
        <span
          className="text-[19px] text-[#0088cc] pl-1 cursor-pointer hover:underline hover:text-[#005580]"
          onClick={() => setShowModal(!showModal)}
        >
          Create
        </span>
      </div>

      {loadingProductOptions || loadingUpdateProductOptions ? (
        <LoadingDesign />
      ) : item?.length <= 0 ? (
        <OopsNoDataDesign />
      ) : (
        <div className="w-[300px] max-w-[500px] sm:w-[500px] transition-all duration-300 px-1 sm:ml-7">
          <Nestable
            items={item}
            renderItem={RenderItem}
            handler={<Handler />}
            maxDepth={2}
            threshold={20}
            showEditModal={showEditModal}
            setShowEditModal={setShowEditModal}
            showDeleteModal={showDeleteModal}
            setShowDeleteModal={setShowDeleteModal}
            setEditProduct={setEditProduct}
            setDragId={setDragId}
          />
        </div>
      )}

      {showModal ? (
        <ProductShowModal
          errors={errors}
          handleSubmit={handleSubmit}
          productsCategoryFormHandler={createProductOptionHandler}
          register={register}
          setShowModal={setShowModal}
          productType="productsOption"
          selectOptions={selectOptions}
          loading={loading}
        />
      ) : null}
      {showEditModal && editProduct ? (
        <ProductShowModal
          errors={errors}
          handleSubmit={handleSubmit}
          productsCategoryFormHandler={updateProductOptionHandler}
          register={register}
          setShowEditModal={setShowEditModal}
          id={editProduct?.id}
          defaultValue={editProduct?.name}
          defaultOptions={editProduct?.options}
          productType="productsOption"
          selectOptions={selectOptions}
          loading={loading}
        />
      ) : null}
      {showDeleteModal && editProduct ? (
        <ProductDeleteModal
          setShowDeleteModal={setShowDeleteModal}
          productType="productsOption"
          loading={loading}
          onDelete={() => {
            if (!loading) {
              if (editProduct?.id) {
                setLoading(true);
                deleteProductOption({
                  variables: {
                    ids: [editProduct?.id],
                  },
                })
                  .then(() => {
                    setLoading(false);
                    setShowDeleteModal(false);
                    refetch();
                  })
                  .catch((errors: any) => {
                    setLoading(false);
                    // alert(error?.message);(errors.message);
                  });
              }
            }
          }}
        />
      ) : null}
    </div>
  );
};

export default ProductsOption;
